export const getTwoArrays = <T>(original: T[], qty: number): [T[], T[]] => {
    const first = original.slice(0, qty);
    const second = original.slice(qty, qty * 2);

    return [first, second];
};
